import { Flex, Button } from 'dash-ui';
import styled from 'styled-components';

export const FlexWraper = styled(Flex)`
  flex-direction: row;
  gap: 10px;
  @media ${({ theme }) => theme.devices.mobile} {
    width: 100%;
    margin-bottom: 0px;
    flex-direction: column;
    & > div {
      margin-right: 0px;
      margin-left: 0px;
      margin-bottom: 12px;
    }
  }
`;

export const IconWraper = styled(Button)`
  display: none;
  @media ${({ theme }) => theme.devices.mobile} {
    display: block;
    justify-content: space-between;
    margin-right: 20px;
  }
`;
